import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: 45,
  },
  filtersContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 37,
    alignItems: 'flex-end',
  },
  filters: {
    display: 'flex',
    flex: '1 1 auto',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    padding: theme.spacing(0, 20, 0, 15),
  },
  datePickerContainer: {
    flex: '0 0 383px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  downloadButton: {
    marginTop: 22,
  },
  search: {
    marginLeft: 50,
    maxWidth: theme.spacing(151),
  },
  defaultText: {
    fontSize: 16,
    color: theme.palette.grey['400'],
    fontWeight: 300,
  },
  strongText: {
    color: theme.palette.common.black,
    fontWeight: 500,
  },
}));
